<section class="full-screen ipad-top-space-margin md-p-0 round-cursor bg-base-color bg-sliding-line position-relative md-h-850px sm-h-750px" id="home">
  <div id="particles-style-01" class="h-100 position-absolute overflow-hidden left-0px top-0 w-100" 
       data-particle="true" 
       data-particle-options='{"particles": {"number": {"value": 15,"density": {"enable": true,"value_area": 2000}},"color": {"value": ["#000000", "#000000", "#000000", "#000000", "#000000"]},"shape": {"type": "circle","stroke":{"width":0,"color":"#000000"}},"opacity": {"value": 0.3,"random": false,"anim": {"enable": false,"speed": 1,"sync": false}},"size": {"value": 8,"random": true,"anim": {"enable": false,"sync": true}},"line_linked":{"enable":false,"distance":0,"color":"#ffffff","opacity":0.4,"width":1},"move": {"enable": true,"speed":1,"direction": "right","random": false,"straight": false}},"interactivity": {"detect_on": "canvas","events": {"onhover": {"enable": false,"mode": "repulse"},"onclick": {"enable": false,"mode": "push"},"resize": true}},"retina_detect": false}'></div>
  <div class="container h-100">
    <div class="row align-items-start align-items-lg-center h-100">
      <div class="col-xl-6 col-lg-8 md-pt-15" >
           <!--data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>-->
        <div class="fs-150 sm-fs-120 lh-110 text-white fw-700 ls-minus-5px">
  <span style="color: transparent; -webkit-text-stroke: 2px white; font-weight: 700;">
    Veedu
  </span>
</div>
        <div class="ps-20">
          <div class="fs-150 sm-fs-120 text-white fw-700 ls-minus-5px">Plan</div>
          <div class="top-minus-40px sm-top-minus-20px right-minus-3px sm-right-0px position-relative">
            <span class="text-white fs-13 lh-36 fw-500 bg-black ps-20px pe-20px text-uppercase d-inline-block ls-1px mb-25px ms-5px">
              Architectural Template Platform
            </span>
            <div class="fs-17 lh-26 text-white fw-500 w-65 md-w-70 sm-w-100">
              From floor plans to elevations, we help architects, students,
              <span class="fw-700 text-decoration-line-bottom-medium text-white">and home owners design smarter and faster.</span>
            </div>
          </div>
        </div>
      </div>
      
      <div style="position: absolute; bottom: 0; right: 0; width: 100%; height: 100%; overflow: hidden; pointer-events: none;">
        <div class="position-absolute right-100px bottom-minus-100px w-55 md-w-60 xs-w-100 md-right-150px xs-right-0px" style="pointer-events: auto;">
          <img src="assets/images/demo-freelancer-03.png" 
               class="position-absolute top-20 right-minus-50px" 
               alt=""
               data-bottom-top="transform: translateY(-150px)" 
               data-top-bottom="transform: translateY(150px)">
          <!--<img src="assets/images/demo-freelancer-04.png" 
               class="position-absolute top-50 left-150px z-index-0 animation-float" 
               alt=""
               data-bottom-top="transform: translateY(-50px)" 
               data-top-bottom="transform: translateY(50px)">-->
          <div class="atropos" data-atropos>
            <div class="atropos-scale">
              <div class="atropos-rotate">
                <div class="atropos-inner text-center">
                  <div data-atropos-offset="-5" class="position-absolute left-0px right-0px">
                    <img src="assets/images/demo-freelancer-01.png" alt="">
                  </div>
                  <img data-atropos-offset="5" class="position-relative" src="assets/images/wire10.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div><br>

 <div 
  class="text-white fw-800 ls-minus-10px text-end text-shadow-large"
  style="font-size: clamp(60px, 15vw, 335px); position: relative; z-index: 9999;">
  Architect
</div>

</section>